import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { emailSignInStart } from './../redux/User/user.actions'
import Button from './forms/Button'

import AuthWrapper from './AuthWrapper'
import FormInput from './forms/FormInput'


const mapState = ({ user }) => ({
	currentUser: user.currentUser
});

const VendorSignIn = props => {

	const dispatch = useDispatch();
	const history = useHistory();
	const { currentUser } = useSelector(mapState);
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	


	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])
	

	useEffect(() =>{
		if(currentUser){
			resetForm();
			const { userRoles } = currentUser;
			if(userRoles.includes('vendor')){
				history.push('/vendorDashboard');
			}else if(userRoles.includes('customer')){
				history.push('/dashboard');
			}else if(userRoles.includes('admin')){
				history.push('/admin');
			}
		}
		// eslint-disable-next-line
	},[currentUser]);


	const resetForm = () => {
		setEmail('');
		setPassword('');
	}

	
	const handleSubmit = e => {
		e.preventDefault();
		dispatch(emailSignInStart({ email, password }))




	}

	const congfigAuthWrapper = {
		headline: 'Vendor Login'
	}
	return (
		<AuthWrapper {...congfigAuthWrapper}>
			<form className="py-5 mx-auto" onSubmit={handleSubmit}>
				<div className="form-group text-left">
					<label htmlFor="email">Email address</label>
						<FormInput 
							type="email" name="email" value={email} handleChange={e => setEmail(e.target.value)} className="form-control" 
						/>
					</div>
					<div className="form-group text-left">
					<label htmlFor="password">Password</label>
						<FormInput 
							type="password" name="password" value={password} handleChange={e => setPassword(e.target.value)} className="form-control" 
						/>
					</div>
					<div>
						
							<Button type="submit">
								SIGN IN
							</Button>
					
						{/* <Button onClick={signInWithGoogle}>
							SIGN IN WITH GOOGLE
						</Button> */}
					</div>
					<div className="mt-3">
						<Link to="/recovery" className="resetLink">
							Reset Password
						</Link>
					</div>
					
					<div className="row  py-5 mb-5">
						<div className="col">
							<h4>Not a member yet?</h4>
						</div>
						<div className="col">
							<Link to="/vendorRegistration">
								<Button >
									SIGN UP
								</Button>
							</Link>
						</div>
					</div>
				</form>
		</AuthWrapper>
	)
}


export default VendorSignIn;